//#region Imports
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { Box } from "@mui/material";
import "../scss/Pages/_tutorials.scss";
import TutorialsData from "../components/TutorialsCatalog/TutorialsData";
import TutorialCard from "../components/TutorialsCatalog/TutorialCard";
import TutorialSearch from "../components/TutorialsCatalog/TutorialSearch";
//#endregion

function Tutorials() {
  const { titleTutorialsString } = useTranslationHook();
  return (
    <Box className="tutorials-catalog-container">
      <Helmet>
        <title>{titleTutorialsString}</title>
      </Helmet>
      <Box className="tcatalog-container">
        <Box className="tcatalog-searchbar-container">
          <TutorialSearch />
        </Box>
        <Box className="tcatalog-main-container">
          {TutorialsData().map((tutorial) => (
            <TutorialCard key={tutorial.id} tutorial={tutorial} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default Tutorials;
